export default function home_hero() {
	
	$('.block-hero .hero-slides').owlCarousel({
    items: 1,
    dotsEach: false,
    loop: true,
    nav: true,
    smartSpeed: 1000,
    mouseDrag: false,
    touchDrag: false,
    navText: ['<i class="fas fa-angle-left"></i><span class="sr-only">Previous</span>','<i class="fas fa-angle-right"></i><span class="sr-only">Next</span>']
  });
	
}